<template>
    <div v-if="isOpen" class="fixed inset-0 top-0rem bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto">
        <h2 class="text-2xl font-bold mb-4 text-gray-800 dark:text-dark-text">Edytuj Rozliczenie dla {{ localOrder.mpk }}</h2>
        <button @click="closeModal" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover">
          <span class="text-xl">&times;</span>
        </button>
        <form @submit.prevent="submitForm" class="space-y-4">
  
          <!-- Km Dyspozytora -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Km Dyspozytora:</label>
            <input
                v-model="localOrder.dispatcherKilometers"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.dispatcherKilometers }"
                @input="validateField('dispatcherKilometers')"
            />
            <span v-if="localErrors.dispatcherKilometers" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.dispatcherKilometers }}</span>
          </div>
  
          <!-- Km Kierowcy -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Km Kierowcy:</label>
            <input
                v-model="localOrder.driverKilometers"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.driverKilometers }"
                @input="validateField('driverKilometers')"
            />
            <span v-if="localErrors.driverKilometers" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.driverKilometers }}</span>
          </div>
  
          <!-- Cena za Km -->
          <!-- <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Cena za Km:</label>
            <input
                v-model="localOrder.pricePerKilometer"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.pricePerKilometer }"
                @input="validateField('pricePerKilometer')"
            />
            <span v-if="localErrors.pricePerKilometer" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.pricePerKilometer }}</span>
          </div> -->

          <div class="flex items-center gap-2">
            <input
                v-model="localOrder.highway"
                type="checkbox"
                class="h-5 w-5 text-teal-600 dark:text-teal-400"
            />
            <label class="text-sm font-medium">Autostrada</label>
            </div>

          <div class="grid grid-cols-1 gap-4">
            <div>
              <label class="block text-sm font-medium">Cena za Km</label>
              <input
                v-model.number="localOrder.pricePerKilometer"
                type="number"
                min="0"
                step="0.01"
                class="w-full p-2 border rounded dark:bg-dark-bg dark:text-dark-text dark:border-dark-border"
              />
            </div>
            <div>
              <label class="block text-sm font-medium">Bramki (Opłata za autostradę)</label>
              <input
                v-model.number="localOrder.driverGates"
                type="number"
                min="0"
                step="0.01"
                class="w-full p-2 border rounded dark:bg-dark-bg dark:text-dark-text dark:border-dark-border"
              />
            </div>
            <div>
              <label class="block text-sm font-medium">Dodatki (Opłata za postój)</label>
              <input
                v-model.number="localOrder.additvies"
                type="number"
                min="0"
                step="0.01"
                class="w-full p-2 border rounded dark:bg-dark-bg dark:text-dark-text dark:border-dark-border"
              />
            </div>
            <!-- <div>
              <label class="block text-sm font-medium">Ryczałt</label>
              <input
                v-model.number="localOrder.flatRate"
                type="number"
                min="0"
                step="0.01"
                class="w-full p-2 border rounded dark:bg-dark-bg dark:text-dark-text dark:border-dark-border"
              />
            </div> -->
            <div>
            <label class="block text-sm font-medium">Suma Łączna</label>
            <input
              :value="calculatedTotalAmount"
              type="number"
              min="0"
              step="0.01"
              class="w-full p-2 border rounded dark:bg-dark-bg dark:text-dark-text dark:border-dark-border bg-gray-100 dark:bg-gray-700 cursor-not-allowed"
              readonly
            />
          </div>
          </div>

          <!-- Checkbox Opłacone -->
          <div class="flex items-center">
            <input
              v-model="localOrder.payoff"
              type="checkbox"
              id="payoff"
              class="mr-2"
            />
            <label for="payoff" class="text-sm font-medium text-gray-700 dark:text-dark-text">Rozliczone</label>
          </div>
  
          <!-- Submit -->
          <div class="flex justify-end">
            <button 
              type="submit" 
              :disabled="isFormInvalid" 
              class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
              :class="{ 'opacity-50 cursor-not-allowed': isFormInvalid }"
            >
              Zapisz zmiany
            </button>
          </div>
  
        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isOpen: Boolean,
      editingOrder: Object,
      errors: Object
    },
    data() {
      return {
        localOrder: {
          ...(this.editingOrder || {
            id: '',
            mpk: '',
            dispatcherKilometers: '',
            driverKilometers: '',
            pricePerKilometer: '',
            payoff: '',
            driverGates: '',
            additvies: '',
            flatRate: '',
            totalAmount: ''
          })
        },
        localErrors: {
          id: '',
          mpk: '',
          dispatcherKilometers: '',
          driverKilometers: '',
          pricePerKilometer: '',
          payoff: '',
          driverGates: '',
          additvies: '',
          flatRate: '',
          totalAmount: ''
        },
        isSubmitting: false
      };
    },
    watch: {
      editingOrder(newVal) {
        if (newVal) {
          this.localOrder = { ...newVal };  // Jeśli dane przychodzą z props, zaktualizuj localOrder
        }
      }
    },
    computed: {
      hasErrors() {
        return Object.values(this.localErrors).some(error => error !== '');
      },
      isFormComplete() {
        // && this.localOrder.pricePerKilometer !== ''
        return this.localOrder.dispatcherKilometers !== '' && this.localOrder.driverKilometers !== '';
      },
      isFormInvalid() {
        return this.hasErrors || !this.isFormComplete;
      },
      calculatedTotalAmount() {
        const km = this.localOrder.dispatcherKilometers || 0;
        const pricePerKm = Number(this.localOrder.pricePerKilometer) || 0;
        const gates = Number(this.localOrder.driverGates) || 0;
        const additvies = Number(this.localOrder.additvies) || 0;
        const flatRate = Number(this.localOrder.flatRate) || 0;

        const total = (km * pricePerKm) + gates + additvies + flatRate;
        return isNaN(total) ? 0 : Number(total.toFixed(2));
      },
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      validateField(field) {
        const value = this.localOrder[field];
        
        // Sprawdzamy, czy wartość jest liczbą i czy jest większa lub równa 0
        const parsedValue = parseFloat(value);
        if (value === '' || isNaN(parsedValue) || parsedValue < 0) {
          this.localErrors[field] = 'Wartość musi być liczbą większą lub równą 0';
        } else {
          this.localErrors[field] = '';
        }
      },
      async submitForm() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        
        // Weryfikacja wszystkich pól przed wysłaniem formularza
        this.validateField('dispatcherKilometers');
        this.validateField('driverKilometers');
        // this.validateField('pricePerKilometer');

        this.localOrder.totalAmount = this.calculatedTotalAmount;
        
        console.log(this.localOrder)

        if (!Object.values(this.localErrors).some(error => error !== '')) {
          this.$emit('submit', this.localOrder);
        } else {
          console.log('Popraw błędy w formularzu przed wysłaniem.');
        }
        
        this.isSubmitting = false;
      }
    }
  };
  </script>
  
  <style scoped>
  /* Pasek przewijania w trybie ciemnym */
  .dark .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #2c7a7a; /* Teal-700 */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #333333; /* Ciemne tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }
  
  /* Pasek przewijania w trybie jasnym */
  .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
  }
  
  .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }
  </style>
  